import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CarouselModule } from 'primeng/carousel';

@Component({
    selector: 'app-jc3-block-3',
    standalone: true,
    imports: [CarouselModule],
    templateUrl: './jc3-block-3.component.html',
    styleUrl: './jc3-block-3.component.scss',
})
export class Jc3Block3Component implements OnChanges {
    @Input() esgData: any;
    cardsData: any = null;
    esgMattersItems: any = [];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['esgData']) {
            const current = changes['esgData'].currentValue;

            if (current?.cards && Object.keys(current.cards).length > 0) {
                this.cardsData = current.cards;
                this.esgMattersItems = [
                    {
                        image: this.cardsData?.icon1_url,
                        title: this.cardsData?.title1,
                        description: this.cardsData?.description1,
                    },
                    {
                        image: this.cardsData?.icon2_url,
                        title: this.cardsData?.title2,
                        description: this.cardsData?.description2,
                    },
                    {
                        image: this.cardsData?.icon3_url,
                        title: this.cardsData?.title3,
                        description: this.cardsData?.description3,
                    },
                ];
            }
        }
    }
}
